import gql from 'graphql-tag';

export const GetGuestMetrics = gql`
  query GetGuestMetrics($userId: String, $deviceId: String, $email: String) {
    guestMetrics(userId: $userId, deviceId: $deviceId, email: $email) {
      result
      errorCode
      guestMetrics {
        riskSignals {
          isFraudSuspicion
          abuseScore
          fraudFlags
          totalRefundsCents
          refundCount
        }
        valueMetrics {
          lifetimeValueCents
          orderCount
          averageOrderValueCents
          orderFrequencyDays
          accountAgeDays
          loyaltyTier
        }
        claimHistory {
          claimId
          orderId
          status
          remediationReason
          remediationMethod
          amountCents
          points
          couponValueCents
          createdAt
          updatedAt
          region
          claimContext
          orderChannel
          agentEmail
          processorEmail
          decision
          offeredAmountCents
          offeredPoints
          offeredCouponValueCents
          offeredMethods
        }
        refundRate
      }
    }
  }
`;
